import { useI18n } from '../lib/i18n';
import type { ViewMode } from '../lib/urlState';

export function Header({
  onOpenMethodology,
  view,
  onView,
}: {
  onOpenMethodology: () => void;
  view: ViewMode;
  onView: (v: ViewMode) => void;
}) {
  const { t, lang, setLang } = useI18n();
  return (
    <header className="border-b border-an-rule bg-an-white">
      <div className="mx-auto flex max-w-[1400px] items-center gap-3 px-4 py-3 md:gap-4 md:px-6">
        <a
          href="https://revistaetnica.com"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center"
          aria-label="Revista étnica"
        >
          <img
            src="/logos/revista-etnica.webp"
            alt="Revista étnica"
            className="h-8 w-auto md:h-10"
          />
        </a>

        <div className="ml-auto flex items-center gap-2">
          <div
            role="tablist"
            aria-label="View"
            className="flex overflow-hidden border border-an-rule"
          >
            <button
              role="tab"
              aria-selected={view === 'map'}
              onClick={() => onView('map')}
              className={[
                'display px-3 py-1.5 text-[11px] uppercase tracking-widest',
                view === 'map'
                  ? 'bg-an-black text-an-white'
                  : 'bg-an-white text-an-ink hover:bg-an-paper',
              ].join(' ')}
            >
              {t('app.view.toggleMap')}
            </button>
            <button
              role="tab"
              aria-selected={view === 'list'}
              onClick={() => onView('list')}
              className={[
                'display border-l border-an-rule px-3 py-1.5 text-[11px] uppercase tracking-widest',
                view === 'list'
                  ? 'bg-an-black text-an-white'
                  : 'bg-an-white text-an-ink hover:bg-an-paper',
              ].join(' ')}
            >
              {t('app.view.toggleList')}
            </button>
          </div>

          <button
            type="button"
            onClick={onOpenMethodology}
            className="display hidden border border-an-rule px-3 py-1.5 text-xs uppercase tracking-wider hover:bg-an-black hover:text-an-white md:inline-block"
          >
            {t('app.methodology.open')}
          </button>
          <button
            type="button"
            onClick={() => setLang(lang === 'es' ? 'en' : 'es')}
            className="display border border-an-rule px-3 py-1.5 text-xs uppercase tracking-wider hover:bg-an-black hover:text-an-white"
            aria-label={t('app.footer.nav.language')}
          >
            {t('app.language.toggle')}
          </button>
        </div>
      </div>

      <div className="border-t border-an-rule bg-an-paper">
        <div className="mx-auto max-w-[1400px] px-4 py-2 md:px-6">
          <p className="font-body text-sm italic text-an-ink md:text-base">
            {t('app.hero')}
          </p>
        </div>
      </div>
    </header>
  );
}
